var map = {
	"./af-report-icon.svg": 31813,
	"./annotations-report-icon.svg": 78592,
	"./blood-pressure-report-icon.svg": 65504,
	"./daily-report-icon.svg": 65701,
	"./events-report-icon.svg": 79007,
	"./monthly-report-icon.svg": 81317,
	"./pwv-report-icon.svg": 38089,
	"./saturation-report-icon.svg": 20880,
	"./sleep-apnea-report-icon.svg": 40041
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98859;